<template>
  <div class="vip">
    <a href="http://vip.koradior.cn/#/"><img src="../../../static/images/vip.png" alt=""></a>
  </div>
</template>

<script>
  export default {
    data () {
      return {}
    },
    components: {
    },
    ready () {
    }
  }
</script>

<style>
  .vip{width:9rem;text-align: center;margin: 0.5rem auto}
  @media screen and (max-width: 30em) and (min-width:20em ){
    .vip{width:100%;text-align: center;margin: 0.5rem auto}
    .vip img{width: 100%;height: 100%}
  }
</style>



// WEBPACK FOOTER //
// vip.vue?6abf3eee